import { Link as DDSLink, LinkProps as DDSLinkProps } from '@norges-domstoler/dds-components';
import { useLinkClickHandler } from 'react-router-dom';
import { getRelativeUrl, IsMediaLink } from '../Utils';
import { useExternalUrl } from './useExternalUrl';

type LinkProps = DDSLinkProps & { langRef?: React.MutableRefObject<undefined>; locationState?: object };

export default function Link(props: LinkProps) {
    const { children, href, langRef, locationState, onClick, ...rest } = props;

    const url = getRelativeUrl(href);
    const isExternalUrl = useExternalUrl(href);
    const isMediaUrl = IsMediaLink(href);
    const isExternalOrMediaUrl = isExternalUrl || isMediaUrl;

    const linkClickHandler = useLinkClickHandler(url, { state: locationState });

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (isExternalOrMediaUrl) {
            if (onClick) onClick(e);
        } else {
            linkClickHandler(e);
            if (onClick) onClick(e);
        }
    };

    return (
        <DDSLink ref={langRef} href={isExternalOrMediaUrl ? href : url} onClick={handleClick} {...rest}>
            {children}
        </DDSLink>
    );
}
